import { useEffect, useReducer } from 'react'

import { NavMenuContentType } from '@hhgtech/hhg-components/components/navigationV2/index'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import { BabyGrowthResultPageProps } from 'components/pages/healthTools/babyGrowth/result'
import {
  BabyGrowthContent,
  BabyGrowthResult,
  FooterInfo,
} from 'interfaces/types'
import { BabyGrowthContext } from 'state/babyGrowth/context'
import { babyGrowthInitialState } from 'state/babyGrowth/initialState'
import { babyGrowthReducer } from 'state/babyGrowth/reducers'
import { BabyGrowthState } from 'state/babyGrowth/types'

import { addResultToLink } from '../helpers'

export type BabyGrowthPageProps = {
  babyGrowthContent: BabyGrowthContent
  babyGrowthResult: BabyGrowthResult
  footerInfo?: FooterInfo
  dataNavMenuContent?: NavMenuContentType
} & Record<string, unknown>

export type BabyGrowthPageType = 'home' | 'result'
const BabyGrowthHomePageComponent = dynamic<BabyGrowthPageProps>(
  () => import('components/pages/healthTools/babyGrowth/home'),
)
const BabyGrowthResultPageComponent = dynamic<BabyGrowthResultPageProps>(
  () => import('components/pages/healthTools/babyGrowth/result'),
)

const BabyGrowthPage = ({
  type,
  ...rest
}: (BabyGrowthPageProps | BabyGrowthResultPageProps) & {
  type: BabyGrowthPageType
}) => {
  const enhancedState: BabyGrowthState = {
    ...babyGrowthInitialState,
    babyGrowthContent: rest.babyGrowthContent,
    babyGrowthResult: (rest as BabyGrowthPageProps)?.babyGrowthResult || null,
  }

  const [state, dispatch] = useReducer(babyGrowthReducer, enhancedState)
  const router = useRouter()
  useEffect(() => {
    if (type !== 'home') {
      if (!router.asPath.includes('?result=1')) {
        const newPath = addResultToLink(router.asPath)
        router.push(newPath, newPath, { shallow: true })
      }
    }
  }, [type])

  if (type === 'home') {
    return (
      <BabyGrowthContext.Provider value={{ state, dispatch }}>
        <BabyGrowthHomePageComponent {...(rest as BabyGrowthPageProps)} />
      </BabyGrowthContext.Provider>
    )
  } else {
    return (
      <BabyGrowthContext.Provider value={{ state, dispatch }}>
        <BabyGrowthResultPageComponent
          {...(rest as BabyGrowthResultPageProps)}
        />
      </BabyGrowthContext.Provider>
    )
  }
}

export { BabyGrowthPage }
